var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContiguous(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.39 7.71V1H1V15.38H7.72V22.09H22.1V7.71H15.39Z",
    stroke: "#55489E",
    strokeWidth: 1.92,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContiguous);
export default __webpack_public_path__ + "static/media/contiguous.f0d78bab.svg";
export { ForwardRef as ReactComponent };